<button id="back-to-top" aria-label="back to top" (click)="taptotop()" [ngClass]="{ 'show-icon': show }">
  <span class="upArrow" [innerHTML]="ICONS.upArrow | safeHtml"></span>
</button>
